import React, { useState } from 'react';
import { FaArrowRight } from "react-icons/fa";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import "../../styles/LandingPageCss/MainHomeSection.css"
import { useModal } from "../../../../../MyContext"

const pricingData = [
  { feature: "Campaign Limit", free: "Up to 10 Campaigns", enterprise: "Unlimited Campaigns" },
  { feature: "Broadcast Messages", free: "Limited", enterprise: "Unlimited" },
  { feature: "Template Creation", free: "Create up to 15 Templates", enterprise: "Unlimited Template Creation" },
  { feature: "Contact Management", free: "Basic", enterprise: "Advanced" },
  { feature: "WhatsApp Chat Inbox", free: "Shared Inbox", enterprise: "Advanced Team Inbox" },
  { feature: "User Access", free: "5–10 Team Members", enterprise: "Unlimited Team Members" },
  { feature: "Chatbot / Automation Flow", free: "Basic", enterprise: "Advanced Automation" },
  { feature: "Analytics & Reports", free: "Basic Analytics", enterprise: "Advanced Analytics & Insights" },
  { feature: "Export Report", free: "5-10 Team Members", enterprise: "Unlimited Team Members" },
  { feature: "Customer Support", free: "Email Support", enterprise: "Priority Support" },
];

export default function Pricing() {
  const [billingCycle, setBillingCycle] = useState('monthly');
  const { openModal } = useModal();

  return (
    <section className="py-5 bg-white font-inter">
      <div className="container">

        <header className="text-center mx-auto mb-5" style={{ maxWidth: "700px" }}>
          <h2 className="new-section-title mb-3 mb-md-4">Pricing</h2>
          <p className="text-muted mt-3">
            Try our free plan risk free for 7 days. switch plans or cancel anytime.
          </p>

          <div className="d-flex justify-content-center mt-4">
            <div className="p-1 border rounded-1 d-flex align-items-center" style={{ background: "#fff" }}>
              <button
                onClick={() => setBillingCycle('monthly')}
                className={`btn rounded-1 px-4 py-2 fw-semibold font-spacegrotesk ${billingCycle === 'monthly' ? 'bg-neon-purple text-white' : 'text-dark border-0'}`}
              >
                Monthly
              </button>
              <button
                onClick={() => setBillingCycle('yearly')}
                className={`btn rounded-1 px-4 py-2 fw-semibold font-spacegrotesk ${billingCycle === 'yearly' ? 'bg-neon-purple text-white' : 'text-dark border-0'}`}
              >
                Yearly <span className="fw-bold ms-1">40% off</span>
              </button>
            </div>
          </div>
        </header>

        
        <div className="row g-4 mb-5 justify-content-center">
          <div className="col-12 col-md-6 col-lg-5">
            <div className="card h-100  pricing-card rounded-0 p-4 pricing-card-hover">
              <h5 className="fw-bold font-spacegrotesk mb-1">Basic</h5>
              <p className="text-muted small">Best for personal use.</p>
              <div className="my-4">
                <span className="h1 fw-bold">₹0</span>
                <span className="text-muted"> / per month</span>
              </div>
              <button
              onClick={openModal}
               className="btn btn-outline-dark rounded-0 fw-bold py-3 border-2 w-100">
                Start Free Trial
              </button>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-5"> 
            <div className="card h-100  pricing-card rounded-0 p-4 text-white pricing-card-hover" style={{ background: "var(--purple)" }}>
              <h5 className="fw-bold font-spacegrotesk mb-1 text-white">Enterprise</h5>
              <p className="text-white opacity-75 small">Best for growing teams.</p>
              <div className="my-4">
                <span className="h1 fw-bold text-white">₹2499 </span>
                <span className="text-white opacity-75"> / per month</span>
              </div>
              <button className="btn btn-light rounded-0 fw-bold py-3 text-primary d-flex align-items-center justify-content-center gap-2 w-100">
                Buy Now <FaArrowRight />
              </button>
            </div>
          </div>
        </div>

        
        <div className="row justify-content-center mb-5">
          <div className="col-12 col-lg-10"> 
            <div className="table-responsive  rounded-0  pricing-table-container">
              <table className="table table-borderless mb-0">
                <thead className="border-bottom border-dark" style={{ background: "#fcfcfc" }}>
                  <tr className="font-spacegrotesk fs-5">
                    <th className="p-4 fw-bold text-dark">Features</th>
                    <th className="p-4 fw-bold text-dark">Free Trial</th>
                    <th className="p-4 fw-bold text-dark">Enterprise</th>
                  </tr>
                </thead>
                <tbody>
                  {pricingData.map((item, index) => (
                    <tr key={index} className="border-bottom align-middle">
                      <td className="p-4 text-dark opacity-75 fw-medium">{item.feature}</td>
                      <td className="p-4 text-muted small">
                        <IoIosCheckmarkCircleOutline className="me-2 text-success" size={18} />
                        {item.free}
                      </td>
                      <td className="p-4 text-dark fw-medium small">
                        <IoIosCheckmarkCircleOutline className="me-2 text-primary" size={18} />
                        {item.enterprise}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}